import React from 'react';
import { AppBar, Box, Button, Container, Stack, Toolbar, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Sermon Archives', to: '/sermon-archives' },
  { label: 'Written Works', to: '/written-works' },
  { label: 'About', to: '/about' },
];

export default function ButtonAppBar() {
  const location = useLocation();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: '#070b21',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 0.5, sm: 1 }, py: 0.75, minHeight: '72px !important' }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            justifyContent="space-between"
            sx={{ width: '100%' }}
          >
            <Typography
              variant="h6"
              component={Link}
              to="/"
              sx={{
                color: '#fff',
                fontWeight: 800,
                textDecoration: 'none',
                letterSpacing: 0.2,
                textAlign: { xs: 'center', sm: 'left' },
              }}
            >
              Darold H. Morgan
            </Typography>

            <Stack
              direction="row"
              spacing={{ xs: 0.25, sm: 0.75 }}
              sx={{
                p: { xs: 0.25, sm: 0.5 },
                borderRadius: 99,
                background: 'rgba(255,255,255,0.08)',
                overflowX: 'auto',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {navItems.map((item) => {
                const isActive =
                  item.to === '/'
                    ? location.pathname === '/'
                    : location.pathname.startsWith(item.to);

                return (
                  <Button
                    key={item.to}
                    component={Link}
                    to={item.to}
                    disableElevation
                    sx={{
                      borderRadius: 99,
                      px: { xs: 0.75, sm: 1.5 },
                      py: { xs: 0.5, sm: 0.75 },
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      textTransform: 'none',
                      fontWeight: isActive ? 700 : 500,
                      color: '#fff',
                      whiteSpace: 'nowrap',
                      background: isActive ? 'linear-gradient(135deg, #6366f1, #8b5cf6)' : 'transparent',
                      boxShadow: isActive ? '0 6px 16px rgba(99,102,241,0.35)' : 'none',
                      '&:hover': {
                        background: isActive
                          ? 'linear-gradient(135deg, #6366f1, #8b5cf6)'
                          : 'rgba(255,255,255,0.12)',
                      },
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
            </Stack>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
